<template>
  <div class="comrade-list">

      <comrade-list-skeleton v-if="loading"></comrade-list-skeleton>

      <div class="comrade-list-container" v-else>

          <div class="swipe swipe-max">
              <van-swipe :autoplay="3000" indicator-color="#fff">
                  <van-swipe-item v-for="item in banners" :key="item.id">
                      <a @click.prevent="toLink(item.target_url)">
                      <!-- <a :href="item.target_url.replace('https://bytx.care-gobroad.com','https://bytx.care-gobroad.com')"> -->
                          <img :src="item.img" alt="">
                      </a>
                  </van-swipe-item>
              </van-swipe>
          </div>

          <div v-if="nav_active === 0">
              <div class="comrade-list-section" v-if="list.length > 0">
                  <van-row @click="$router.push({name:'comrade-detail',params:{id:item.id}})" v-for="item in list" :key="item.id">
                      <div v-if="item.type===1" class="comrade-list-section-box">
                          <div class="comrade-list-section-left">
                              <van-image
                                  fit="cover"
                                  class="comrade-list-section-left-img"
                                  :src="item.cover_img"
                                  width="100%"
                                  height="100%"
                              />
                          </div>
                          <div class="comrade-list-section-right">
                              <div class="comrade-list-section-right-title">{{item.title}}</div>
                          </div>
                          <div class="clear"></div>
                          <div class="comrade-list-section-stats">
                              <img src="/static/bytx/companion_list_read_icon.svg" alt=""> <span>{{item.view_count}}</span>
                              <img src="/static/bytx/companion_list_helpful_icon.svg" alt=""> <span>{{item.like_count}}</span>
                              <img src="/static/bytx/companion_list_comment_icon.svg" alt=""> <span>{{item.comment_count}}</span>
                          </div>
                          <div class="clear"></div>
                      </div>
                      <div class="comrade-list-section-box" v-else>
                          <div class="comrade-list-section-title">{{item.title}}</div>
                          <van-image
                              fit="cover"
                              class="comrade-list-section-left-img"
                              :src="item.cover_img"
                              width="100%"
                              height="100%"
                          />
                          <img class="comrade-list-section-play-btn" src="/static/bytx/list_video_play_2.svg" alt="">
                          <div class="comrade-list-section-stats">
                              <img src="/static/bytx/companion_list_comment_icon.svg" alt=""> <span>{{item.view_count}}</span>
                              <img src="/static/bytx/companion_list_helpful_icon.svg" alt=""> <span>{{item.comment_count}}</span>
                              <img src="/static/bytx/companion_list_read_icon.svg" alt=""> <span>{{item.like_count}}</span>
                          </div>
                          <div class="clear"></div>
                      </div>
                  </van-row>
              </div>
              <div class="van-list__finished-text" v-if="list.length > 6 && page === total_page">已到底部</div>
              <div v-else-if="list.length > 0 && total_page > page" class="finish-more" @click="fetch_more()">查看更多</div>
              <van-empty v-else-if="list.length === 0" description="" image="/static/img/pic_blank_content.svg" >
                  <template slot="description">
                      <!--<div style="text-align: center">已到底部</div>-->
                      <div style="text-align: center">博医同行持续更新中…</div>
                      <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                      <div style="text-align: center;margin-top: 24px">
                          <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                              返回首页
                          </van-button>
                      </div>
                  </template>
              </van-empty>
          </div>
          <div v-else>

              <div class="tags">
                  <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
                      <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
                  </van-tabs>
                  <div class="clear"></div>
              </div>

              <div class="comrade-list-section group" v-if="group.length > 0">
                  <van-row class="comrade-list-section-box" @click="joinGroup(item)" v-for="item in group" :key="item.id">
                      <div class="comrade-list-section-left">
                          <van-image
                              fit="cover"
                              class="comrade-list-section-left-img"
                              :src="item.cover_img"
                              width="100%"
                              height="100%"
                          />
                      </div>
                      <div class="comrade-list-section-right">
                          <div class="comrade-list-section-right-title">{{item.title}}</div>
                          <div class="comrade-list-section-right-desc">
                              {{item.desc.length > 26 ? item.desc.substr(0,26)+'...' : item.desc}}
                          </div>
                      </div>
                      <div class="comrade-list-section-btn">
                          申请入群
                      </div>
                      <div class="clear"></div>
                  </van-row>
              </div>

              <div class="van-list__finished-text" v-if="group.length > 0 && group_page === group_total_page">已到底部</div>
              <div v-else-if="group.length > 0 && group_total_page > group_page" class="finish-more" @click="fetch_more()">查看更多</div>
              <van-empty v-else description="" image="/static/img/pic_blank_content.svg" >
                  <template slot="description">
                      <!--<div style="text-align: center">已到底部</div>-->
                      <div style="text-align: center">博医同行持续更新中…</div>
                      <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                      <div style="text-align: center;margin-top: 24px">
                          <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                              返回首页
                          </van-button>
                      </div>
                  </template>
              </van-empty>
          </div>

          <van-dialog class="add_wechat" v-model="openDialog" :showConfirmButton="false">
              <template slot="title">
                  <div class="close-pop" @click="closeFeedback">
                      <img src="/static/bytx/popup_close_icon.svg" alt="">
                  </div>
                  <h3>申请入群</h3>
              </template>
              <div class="clear"></div>
              <div>长按识别下方二维码添加小助手,申请入群</div>
              <div align="center" style="margin-top: 12px;color: #9D9D9D">
                  <img src="/static/bytx/qrcode/zyq_v2.jpeg" alt="">
              </div>
          </van-dialog>

          <div class="pre-page">
              <img src="/static/bytx/public/welfare_back_btn.svg" @click="$router.push({name:'welfare-zone'})">
          </div>

      </div>
  </div>
</template>
<script>
    import Interface from "@/util/interface"
    import articleListSkeleton from "@/skeleton/articleListSkeleton"
    import {LocationHref} from '@/util/common'
    export default {
        name: 'comrade-list',
        components :{
            'comrade-list-skeleton' : articleListSkeleton
        },
        data() {
            return {
                value: "",
                category_id :0,
                category_child_id:0,
                category_index:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true,
                page:1,
                pageSize:10,
                total_page:1,

                group:[],
                group_page:1,
                group_pageSize:10,
                group_total_page:1,

                nav_active:0,
                active:1,

                openDialog:false,
                group_title_text:"",
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'banner') {
                    Interface.getData('get', Interface.banner, {type: 7}).then((res) => {
                        this.banners = res.data
                    })
                } else if (scene === 'comrade') {
                    this.page = 1
                    let params = {
                        page:this.page,
                        pageSize:this.pageSize,
                        category_id : this.category_id,
                    }
                    Interface.getData('get', Interface.comrade.list,params).then((res) => {
                        if(res.data.list != null){
                            this.list = res.data.list
                            this.total_page = res.data.total_page
                        }else{
                            this.list = [];
                            this.total_page = 1
                        }
                        setTimeout(()=>{this.loading = false;},500)
                    })
                } else if (scene === 'group') {
                    this.page = 1
                    let params = {
                        page:this.group_page,
                        //pageSize:this.group_pageSize,
                        pageSize:999,
                        category_id : this.category_id,
                    }
                    Interface.getData('get', Interface.comrade.group,params).then((res) => {
                        if(res.data.list != null){
                            this.group = res.data.list
                            this.group_total_page = res.data.total_page
                        }else{
                            this.group = [];
                            this.group_total_page = 1
                        }
                        setTimeout(()=>{this.loading = false;},500)
                    })
                } else if (scene === 'category') {
                    Interface.getData('get', Interface.category,{type:10}).then((res) => {
                        this.categories = res.data.list
                        this.categories.unshift({name:"推荐",id:0})
                        if(this.categories.length < 5){
                            for(let i=999;i<= (1007 - this.categories.length);i++){
                                this.categories_child.push({name:"",id:i})
                            }
                        }
                    })
                }
            },
            fetch_more(){
                this.page += 1
                let params = {
                    page : this.page,
                    pageSize:10,
                    category_id : this.category_id,
                }
                Interface.getData('get', Interface.comrade.list,params).then((res) => {
                    this.list.push(...res.data.list)
                    this.total_page = res.data.total_page
                })
            },
            changeCategory(){
                this.category_id = this.categories[this.category_index].id
                this.fetch("group")
            },
            closeFeedback(){
                this.openDialog = false
            },
            joinGroup(item){
                Interface.getData('get',Interface.user.apply_group+item.id)
                this.group_title_text = "申请加入"+item.title+"，长按识别添加小助手微信，我们将及时与您进行一对一沟通交流。"
                this.openDialog = true
            },
            toLink(url){
                const links = url.replace('https://bytx.care-gobroad.com', '')
                LocationHref(links)
            },
        },
        created() {
            Interface.footPrint(20,1,0,"浏览博医同行交流社区")
            // Interface.listShareInfo(this,5)
            this.fetch('banner')
            this.fetch('comrade')
            this.fetch('group')
            this.fetch('category')
            sessionStorage.removeItem("search_data")
        },
    }
</script>
<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/community/story/index.vue